import Render from '@Views/root/patients/campaigns/context-campaigns.html'
import { Component, Vue } from 'vue-property-decorator'

@Render
@Component({})
export class ContextCampaigns extends Vue {}